import { HttpMethod } from '../components/Common/useFetch';
import { RequestOptions } from '../components/Common/useRequest';
import useUserRequest from '../components/Common/useUserRequest';
import { useSelectedBusiness } from '../components/UserAccess/useSelectedBusiness';

interface VoidOrderTransactionRequest {
  reason?: string;
}

const useVoidOrderTransaction = (orderTransactionId: string, options: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<VoidOrderTransactionRequest>({
    method: HttpMethod.POST,
    path: `/api/businesses/${business.id}/ordertransactions/${orderTransactionId}/void`,
  }, options);
};

export default useVoidOrderTransaction;
